import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import isBase64Image from '../../utils/isBase64Image';
import theme from './UserIcon.scss';

const propTypes = {
  imgData: PropTypes.string,
  initials: PropTypes.string,
  className: PropTypes.string,
};

const defaultProps = {
  imgData: '',
  initials: '',
  className: '',
};

const UserIcon = ({
  imgData,
  initials,
  className,
}) => (
  isBase64Image(imgData) ? (
    <div
      className={ classnames(theme.root, theme.imageBlock, className) }
      style={{ backgroundImage: `url(data:image/svg+xml+jpg+jpeg+png;${ imgData })` }}
    />
  ) : (
    <div className={ classnames(theme.root, className) }>
      <div className={ theme.initialsContainer }>
        { initials }
      </div>
    </div>
  )
);

UserIcon.propTypes = propTypes;
UserIcon.defaultProps = defaultProps;

export default UserIcon;
